module.exports = __webpack_public_path__ + "static/media/picture-(48).9ef27ad0.JPG";